import script from "./JobTemplatesEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./JobTemplatesEdit.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__